export { NewModal } from './NewModal.component.jsx';
